import { fetchCSRFToken } from "../csrf";

type ConfirmActionProps = {
  action?: string,
  method: string,
  question?: string,
};

function getActionUrl(el: HTMLElement, props: ConfirmActionProps): string | undefined {
  if (props.action) {
    return props.action;
  }

  if (el instanceof HTMLAnchorElement) {
    return el.href;
  }
}

/**
 * Take a `button` or `a` and, on click, allow the default event to propagate
 * or create a form with `props.action` (and optionally `props.method`) and
 * submit it.
 */
export default function confirmAction(el: HTMLElement, props: ConfirmActionProps) {
  const question = props.question;
  const action = getActionUrl(el, props);
  if (!action) {
    return;
  }

  el.addEventListener("click", async (ev) => {
    ev.preventDefault();

    // we need to stop event propagation to prevent the turbolinks-style
    // thingy from handling this link click and doing it anyway
    ev.stopPropagation();

    const confirmed = question === undefined ? true : window.confirm(question);
    if (!confirmed) {
      return;
    }

    const formMethod = props.method === "GET" ? "GET" : "POST";

    const form = document.createElement("form");
    form.setAttribute("method", formMethod);
    form.setAttribute("action", action);
    form.style.display = "none";

    if (props.method === "PUT" || props.method === "DELETE") {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", "_method");
      input.setAttribute("value", props.method === "PUT" ? "put" : "delete");
      form.appendChild(input);
    }

    if (props.method !== "GET") {
      const csrfToken = await fetchCSRFToken();
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", "_csrf");
      input.setAttribute("value", csrfToken);
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  });
}
